'use strict';



const $ = require('jquery');
const loadJs = require('fg-loadjs');
const debounce = require('debounce');
const $graph = $('.js-growth-graph');
const apiUrl = 'https://www.google.com/jsapi';
const data = window.growthGraph;
let $graphContainer;
let rerender;

const graphOptions = {
	height: 400,
	vAxes: {
		0: {
			title: 'Loan Completion Value',
			format: '\u00A3####,### million',
			textStyle: {
				fontSize: 9,
				color: '#1c7cba'
			}
		},
		1: {
			title: 'Registered Users',
			textStyle: {
				fontSize: 9,
				color: '#8eca3e'
			}
		}
	},
	hAxis: {
		textStyle: {
			fontSize: 9
		}
	},
	series: {
		0: {
			targetAxisIndex: 0,
			curveType: 'function',
			color: '#1c7cba'
		},
		1: {
			targetAxisIndex: 1,
			curveType: 'function',
			color: '#8eca3e'
		}
	},
	legend: {
		position: 'none'
	},
	pointSize: 3
};



if(data && $graph.length > 0) {
	init();
}



function init() {

	rerender = debounce(render, 600);
	$graphContainer = $('<div>').insertAfter($graph);

	loadApi(() =>  {
		render();
		$(window).on('resize', rerender);
	});

}



function render() {

	const { google } = window;
	const { LineChart, DataTable } = google.visualization;
	const chart = new LineChart($graphContainer[0]);
	const table = new DataTable();

	table.addColumn('string', 'X');
	table.addColumn('number', 'Loan Completion Value (\u00A3 million)');
	table.addColumn('number', 'Registered Users');
	table.addRows(data.rows);

	chart.draw(table, graphOptions);

}



function loadApi(next = function() {}) {
	loadGoogleApi(loadChartsApi.bind(null, next));
}



function loadGoogleApi(next = function() {}) {
	loadJs(apiUrl, next);
}



function loadChartsApi(callback = function() {}) {
	window.google.load('visualization', 1, {
		packages: [ 'corechart', 'line' ],
		callback
	});
}